import { Platform } from "react-native"
import { File } from "expo-file-system"
import { compressImage, generateThumbhash } from "rn-remove-image-bg"
import { useMutation } from "@tanstack/react-query"

import { ImageEntity } from "@white-labels/input/src/m5azen"

import { trpcClient } from "@src/utils"

export function useUploadImage() {
  return useMutation({
    mutationFn: async (args: { uri: string; entity: ImageEntity; entityId: number }) => {
      // Skip compression on web to test if it's causing transparency loss
      const compressedUri = await compressImage(args.uri)
      const thumbhash = await generateThumbhash(compressedUri)
      const formData = new FormData()
      formData.append("entity", args.entity)
      formData.append("entityId", args.entityId.toString())
      formData.append("thumbhash", thumbhash)
      if (Platform.OS === "web") {
        const response = await fetch(compressedUri)
        const blob = await response.blob()
        if (blob.size > 1024 * 1024) throw new Error("Image size exceeds 1MB even after compression")
        formData.append("image", blob, "image.webp")
      } else {
        const info = new File(compressedUri).info()
        if (!info.size || info.size > 1024 * 1024) throw new Error(`Image size (${Math.round((info?.size ?? 0) / 1024)}KB) exceeds 1MB limit`)

        // biome-ignore lint/suspicious/noExplicitAny: React Native FormData accepts this format
        formData.append("image", { uri: compressedUri, type: "image/webp", name: "image.webp" } as any)
      }
      return trpcClient.images.uploadImage.mutate(formData)
    },
  })
}
